import { Spinner } from '@wartek-id/spinner'

import { useAsesmenRefleksiPeriod } from 'app/PemetaanKompetensiPage/hooks/useAsesmenRefleksiPeriod'
import LoadingState from 'app/PemetaanKompetensiPage/components/LoadingState'
import PeriodGuardChecker from './PeriodGuardChecker'

interface IPeriodGuard {
  currentDateTimeServer: string
  children?: JSX.Element
  fullPageLoading?: boolean
  forceLoading?: boolean // add force loading when needed
}

const PeriodGuard = ({
  currentDateTimeServer,
  children,
  fullPageLoading = false,
  forceLoading = false,
}: IPeriodGuard) => {
  const periodData = useAsesmenRefleksiPeriod(currentDateTimeServer)

  if (periodData.isLoading || forceLoading)
    return fullPageLoading ? (
      <LoadingState title="Halaman sedang dimuat..." />
    ) : (
      <Spinner />
    )

  return (
    <PeriodGuardChecker periodData={periodData}>{children}</PeriodGuardChecker>
  )
}

export default PeriodGuard
